<template>
  <div class="modal fade" id="subscription-result-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div
      :class="['modal-dialog',
    {'loading-dialog': loading},
    {'success-dialog': !loading && subscriptionInfo.status === 'active'},
    {'failure-dialog': !loading && subscriptionInfo.status !== 'active'}
    ]"
      role="document"
    >
      <div class="modal-content" id="loading" v-if="loading">
        <spinner :show="loading" class="spinner-component"></spinner>
      </div>

      <div class="modal-content" id="success" v-else-if="subscriptionInfo.status === 'active'">
        <modal-header></modal-header>
        <div class="modal-body text-center">
          <img src="/static/img/dashboard/success_2x.png" alt=" " />
          <h4>{{$t('subscribedSuccessfully') }}</h4>
          <p class="payment-info">
            <span>{{ $t('price') }}</span>
            <span class="pull-right">{{ $t(subscriptionInfo.package_detail.currency_code) }} {{ subscriptionInfo.package_detail.price }}</span>
          </p>
          <p class="payment-info">
            <span>{{ $t('deviceNum') }}</span>
            <span
              class="pull-right"
            >{{ subscriptionInfo.package_detail.device_count }} {{ $tc('devices', subscriptionInfo.package_detail.device_count) }}</span>
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" data-dismiss="modal" @click="gtmEvent('subscribe_success')">{{ $t('sure') }}</button>
          <p>{{ $t('reviewNotice') }}</p>
        </div>
      </div>

      <div class="modal-content" id="failed" v-else-if="subscriptionInfo.status !== 'active'">
        <modal-header></modal-header>
        <div class="modal-body text-center">
          <img src="/static/img/dashboard/failure_2x.png" alt=" " />
          <h4 class="text-center">{{$t('subscribedFailure') }}</h4>
          <p>{{ $t('queryNotice') }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" data-dismiss="modal" @click="gtmEvent('subscribe_fail')">{{ $t('sure') }}</button>
          <p>{{ $t('contactUs') }}</p>
          <p class="email">iplexservice@gmail.com</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '../../Spinner.vue';
import ModalHeader from '../../modalHeader/ModalHeader.vue';
import $ from 'jquery';
import locales from './lang';
import { mapState } from 'vuex';
import { isMobile, isAndroid, isIOS, isMac, isWindows } from '../../../lib/fun';
import cookie from '../../../lib/cookie';
import * as types from '../../../store/mutation-types';

export default {
  name: 'subscription-result-modal',
  components: { Spinner, ModalHeader },
  data: function() {
    return {
      loading: true
    };
  },
  locales,
  computed: {
    showCurrentComponent() {
      return this.querySubscriptionStatus && !!this.subscriptionId;
    },
    removeStorageInfo() {
      return !!this.$route.query.subscription_id;
    },
    ...mapState({
      subscriptionId: state => state.subscribe.subscriptionId,
      querySubscriptionStatus: state => state.subscribe.querySubscriptionStatus,
      subscriptionInfo: state => state.subscribe.subscriptionInfo,
      currentSymbol: state => state.currentSymbol
    })
  },
  watch: {
    showCurrentComponent() {
      if (this.showCurrentComponent) {
        $('#subscription-result-modal').modal('show');
        this.getSubscriptionInfo();
      }
    }
  },
  mounted() {
    let _this = this;
    $('#subscription-result-modal').on('hidden.bs.modal', function() {
      _this.resetData();
      _this.$store.commit('setUpdatePackageInfo', true);
    });
  },
  methods: {
    getSubscriptionInfo() {
      this.loading = true;
      this.$store.dispatch('getSubscription').then(response => {
        this.loading = false;
        if (response.body.code === 0) {
          window.localStorage.removeItem('isQuerySubscriptStatus');
          if (response.body.data.status === 'active') {
            if (cookie.getCookie('promotion_source')) {
              cookie.removeCookie('promotion_source');
            }
          }
        }
      });
    },
    resetData() {
      this.loading = false;
      this.$store.commit(types.RESET_SUBSCRIPTION);
      this.$store.commit('setSubscriptionId', '');
      this.$store.commit('setQuerySubscriptionStatus', false);
      if (this.removeStorageInfo) {
        window.localStorage.removeItem('subscriptionId');
        window.localStorage.removeItem('currentPackage');
      }
      this.$store.commit('setCurrentPayment', '');
      this.$store.dispatch('getUserInformation');
    },
    gtmEvent(eventName) {
      if (isMobile()) {
        if (isAndroid()) {
          eventName = 'Android_H5_' + eventName;
        } else if (isIOS()) {
          eventName = 'iOS_H5_' + eventName;
        } else {
          eventName = 'other_H5_' + eventName;
        }
      } else {
        if (isMac()) {
          eventName = 'Mac_PC_' + eventName;
        } else if (isWindows()) {
          eventName = 'Windows_PC_' + eventName;
        } else {
          eventName = 'other_PC_' + eventName;
        }
      }
      if (eventName.indexOf('subscribe_success') !== -1) {
        window.dataLayer &&
          window.dataLayer.push({
            // Event snippet for subscribe page
            event: eventName,
            pageCategory: 'subscript',
            transactionId: this.subscriptionInfo.subscription_id,
            transactionTotal: this.subscriptionInfo.package_detail.price,
            transactionCurrency: this.subscriptionInfo.package_detail.currency_code,
            transactionProducts: [
              {
                name: this.subscriptionInfo.package_detail.name,
                price: this.subscriptionInfo.package_detail.price,
                deviceCount: this.subscriptionInfo.package_detail.device_count
              }
            ],
            ecommerce: {
              subscribe: {
                actionField: {
                  id: this.subscriptionInfo.subscription_id, // Transaction ID. Required for purchases and refunds.
                  revenue: this.subscriptionInfo.package_detail.price, // Total transaction value (incl. tax and shipping)
                  currency: this.subscriptionInfo.package_detail.currency_code
                },
                products: [
                  {
                    // List of productFieldObjects.
                    name: this.subscriptionInfo.package_detail.name, // Name or ID is required.
                    price: this.subscriptionInfo.package_detail.price,
                    deviceCount: this.subscriptionInfo.package_detail.device_count
                  }
                ]
              }
            }
          });
      } else {
        window.dataLayer &&
          window.dataLayer.push({
            event: eventName,
            pageCategory: 'subscript',
            transactionId: this.subscriptionInfo.subscription_id,
            transactionTotal: this.subscriptionInfo.package_detail.price,
            transactionCurrency: this.subscriptionInfo.package_detail.currency_code,
            transactionProducts: [
              {
                name: this.subscriptionInfo.package_detail.name,
                price: this.subscriptionInfo.package_detail.price,
                deviceCount: this.subscriptionInfo.package_detail.device_count
              }
            ]
          });
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../../assets/scss/variables';
@import '../../../assets/scss/reset-modal';
@import '../../../assets/scss/mixins/button';

.modal {
  .modal-dialog {
    #loading {
      padding: ((3.72rem - 0.5rem)/2) 0;
    }
    @media (max-width: 767px) {
      #loading {
        padding: ((4rem - 0.5rem)/2) 0;
      }
    }
  }
  .loading-dialog {
    @include modal-dialog($height: 3.72rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 1.86rem) 0 0 -45% !important;
    }
  }
  .success-dialog {
    @include modal-dialog($height: 5rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 2.5rem) 0 0 -45% !important;
    }
  }
  .failure-dialog {
    @include modal-dialog($height: 5.3rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 2.65rem) 0 0 -45% !important;
    }
  }
}

.modal-body {
  padding: 0 0.2rem;
  color: #333;
  line-height: 0.28rem;
  img {
    width: 0.5rem;
    margin-bottom: 0.2rem;
  }
  h4 {
    font-size: 0.24rem;
    margin-bottom: 0.6rem;
  }
  p {
    font-size: 0.16rem;
    letter-spacing: 0.71px;
    &.payment-info {
      text-align: left;
      margin-bottom: 0.1rem;
    }
  }
}

.modal-footer {
  text-align: center;
  position: absolute;
  bottom: 0.4rem;
  width: calc(100% - 0.4rem);
  button {
    @include modal-button();
    margin-bottom: 0.4rem;
  }
  p {
    line-height: 0.28rem;
    letter-spacing: 0.53px;
    color: #999999;
    font-size: 0.12rem;
    &.email {
      font-size: 0.14rem;
      color: #416cf8;
    }
  }
}

#loading {
  .spinner-component {
    margin: 0 auto;
  }
}
</style>


// WEBPACK FOOTER //
// SubscribeResult.vue?ea8fbb20